import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsEmpresaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/empresa');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Empresa');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/empresa', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Empresa');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/empresa', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Empresa');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/empresa/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Empresa');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.post('/empresa/update', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Empresa');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/empresa/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Empresa');
    }
  }
}
